{
  "search": "Cercare",
  "login": "Identificativo",
  "firstname": "Nome",
  "lastname": "Cognome",
  "email": "E-mail",
  "addUserGroup": "Aggiungere un gruppo",
  "selectUserProfile": "Selezionare un profilo",
  "profile": "Profilo",
  "userProfile": "Profilo utente",
  "language": "Lingua",
  "label": "Nome",
  "error": {
    "required": "Campi obbligatori",
    "maxLength": "Lunghezza max: {maxLength}",
    "invalidFormat": "Formato non valido",
    "lowercaseOnly": "Solo minuscole"
  },
  "url": "URL",
  "deleteFile": "Fai clic per eliminare il file",
  "password": "Password",
  "nominalTemplateName": "Nome del template nominale",
  "bootstrapTemplateName": "Nome del template bootstrap",
  "secondIntervalTime": "Tempi di intervallo (secondi)",
  "profileName": "Nome del profilo",
  "languages": {
    "en": "Inglese (English)",
    "fr": "Francese (Français)",
    "it": "Italiano",
    "es": "Spagnolo (Español)",
    "de": "Tedesco (Deutsch)"
  },
  "passwordPlaceholder": "**********",
  "clickToUpload": "Fai clic per importare",
  "orDragAndDrop": "o eseguire un drag-and-drop del file in formato {format}",
  "orDragAndDropWithoutExtension": "\no eseguire un drag-and-drop",
  "information": {
    "more": "Per maggiori informazioni"
  },
  "select": {
    "search": {
      "placeholder": "Cerca",
      "noResults": "Nessun risultato"
    }
  },
  "timezone": {
    "placeholder": "Seleziona fuso orario"
  },
  "selectAll": "Seleziona tutto",
  "optional": "Opzionale"
}
